import { render, staticRenderFns } from "./CrmLeadImported.vue?vue&type=template&id=491747af&scoped=true&"
import script from "./CrmLeadImported.vue?vue&type=script&lang=js&"
export * from "./CrmLeadImported.vue?vue&type=script&lang=js&"
import style0 from "./CrmLeadImported.vue?vue&type=style&index=0&id=491747af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491747af",
  null
  
)

export default component.exports